module.exports = __webpack_public_path__ + "static/media/poppy.7fd78f5d.png";